import buttonFormFields from '@/components/sections/form-fields/content/button'
import sectionFormFields from '@/components/sections/form-fields/design/section'
import structureFormFields from '@/components/sections/form-fields/layout/structure'
import contentBoxFormFields from '@/components/sections/form-fields/layout/content-box'

export const content = {
  title: {
    label: 'Title',
    type: 'text'
  },
  introtext: { label: 'Introtext', type: 'text-editor' },
  image: {
    label: 'Image',
    type: 'media-manager'
  },
  buttons: {
    label: 'Buttons',
    type: 'repeatable',
    fields: buttonFormFields
  }
}

export const design = {
  ...sectionFormFields,
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Text'
  },
  'introtext-color': {
    label: 'Introtext color',
    type: 'text-color',
    category: 'Text'
  }
}

export const layout = {
  ...structureFormFields,
  'content-vertical-alignment': {
    label: 'Content vertical alignment',
    type: 'radio',
    options: [
      { value: 'start', text: 'Top' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Bottom' }
    ],
    category: 'Structure'
  },
  'image-size': {
    label: 'Image size',
    type: 'radio',
    options: [
      { value: 'sm', text: 'Small' },
      { value: 'md', text: 'Medium' },
      { value: 'lg', text: 'Large' }
    ],
    category: 'Image'
  },
  'image-position': {
    label: 'Image position',
    type: 'radio',
    options: [
      { value: 'left', text: 'Left' },
      { value: 'right', text: 'Right' }
    ],
    category: 'Image'
  },
  ...contentBoxFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
